import { BottomNavigation, BottomNavigationAction, Box, Paper } from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setPrompt } from "store/actions/prompt";
import { isDynamicRouteMatch } from "utils/common";
import { ATTENTION_MESSAGE } from "utils/constants";

const NAV_ITEMS = [
  {
    label: "Accueil",
    src: "/assets/logo/home.svg",
    path: "/",
    matchFn: (p) => p === "/",
  },
  {
    label: "Fitness",
    src: "/assets/logo/programmes.svg",
    path: "/fitness/programs",
    matchFn: (p) => p.startsWith("/fitness"),
  },
  {
    label: "Nutrition",
    src: "/assets/logo/recipe_programs.svg",
    path: "/nutrition/programs",
    matchFn: (p) => p.startsWith("/nutrition"),
  },
  {
    label: "Ressources",
    src: "/assets/logo/formations.svg",
    path: "/tutoriels",
    matchFn: (p) => p.startsWith("/tutoriels"),
  },
  {
    label: "Compte",
    src: "/assets/logo/settings.svg",
    path: "/settings",
    matchFn: (p) => p.startsWith("/settings"),
  },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const activeValue = NAV_ITEMS.find((item) => item.matchFn(pathname))?.path ?? false;

  const handleNav = (path) => {
    if (isDynamicRouteMatch(pathname)) {
      dispatch(
        setPrompt({
          isOpen: true,
          message: ATTENTION_MESSAGE,
          primaryBtnHandler: () => navigate(path),
          btnAlign: "right",
          primaryBtnColor: "error",
          secondaryBtnText: "Annuler",
        })
      );
    } else {
      navigate(path);
    }
  };

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        display: { xs: "block", lg: "none" },
        borderTop: "1px solid #E0E4EA",
      }}
      elevation={0}
    >
      <BottomNavigation
        showLabels
        value={activeValue}
        sx={{ height: 60 }}
      >
        {NAV_ITEMS.map((item) => {
          const isActive = activeValue === item.path;
          return (
            <BottomNavigationAction
              key={item.path}
              label={item.label}
              value={item.path}
              icon={
                <Box
                  component="img"
                  src={item.src}
                  alt={item.label}
                  sx={{
                    width: 22,
                    height: 22,
                    filter: isActive
                      ? "none"
                      : "grayscale(1) opacity(0.45)",
                    transition: "filter 0.15s ease",
                  }}
                />
              }
              onClick={() => handleNav(item.path)}
              sx={{
                minWidth: 0,
                padding: "6px 4px",
                ".MuiBottomNavigationAction-label": {
                  fontSize: "10px",
                  "&.Mui-selected": { fontSize: "10px" },
                },
              }}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
